<template>
  <div class="landing-page">
    <div class="top">
      <h1 class="title gyra-h1-normal-serif">
        {{ "landing_page.titles.main_title" | translate }}
      </h1>
      <p class="sub-title">
        {{ "landing_page.titles.sub_title" | translate }}
      </p>
      <div class="shop-button-container">
        <div class="shop-button" @click="visitRecommendationPage">
          {{ "landing_page.titles.shop_online" | translate }}
        </div>
        <div class="shop-button" @click="onLocateClick">
          {{ "landing_page.titles.shop_offline" | translate }}
        </div>
      </div>
      <div class="map-image map-image-pos"></div>
      <div class="gradient map-image-pos"></div>
    </div>

    <div class="stores">
      <div class="title-and-button">
        <div class="title-emoji">
          <h3>
            {{ "landing_page.titles.stores" | translate }}
          </h3>
        </div>
        <div @click="visitStoreMap" class="more-button">
          {{ "landing_page.titles.see_more" | translate }}
        </div>
        <BIconArrowRightShort class="right-arrow" @click="visitStoreMap" />
      </div>
    </div>
    <div class="store-row-container">
      <div class="store-row">
        <div
          class="store-container"
          v-for="(store, i) in stores"
          :key="i"
          @click="visitStorePage(store.storeName)"
        >
          <div
            class="store-logo"
            :style="{
              backgroundImage: `url(${require(`../assets/images/store_logos/${store.storeName}.png`)})`
            }"
          ></div>
        </div>
      </div>
    </div>

    <div class="selection">
      <div class="title-and-button">
        <div class="title-emoji">
          <h3>
            {{ "landing_page.titles.selection" | translate }}
          </h3>
        </div>
        <div @click="visitRecommendationPage" class="more-button">
          {{ "landing_page.titles.see_more" | translate }}
        </div>
        <BIconArrowRightShort
          class="right-arrow"
          @click="visitRecommendationPage"
        />
      </div>
      <div class="product-row">
        <product-card
          v-for="(product, j) in selection"
          :key="j"
          :product="product"
          @card-clicked="visitProductPage"
          class="product-card--general"
        />
      </div>
    </div>

    <div class="banner">
      <h3>{{ "landing_page.titles.banner" | translate }}</h3>
    </div>

    <div class="brands">
      <div class="title-and-button">
        <div class="title-emoji">
          <h3>
            {{ "landing_page.titles.brands" | translate }}
          </h3>
        </div>
        <div @click="visitBrandPage" class="more-button">
          {{ "landing_page.titles.see_more" | translate }}
        </div>
        <BIconArrowRightShort class="right-arrow" @click="visitBrandPage" />
      </div>
      <div class="brand-matrix">
        <div class="brand-container" v-for="(brand, k) in brands" :key="k">
          <p>{{ brand }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  applyFilter,
  getPossibleFilterValues,
  getSample,
  getStores
} from "../services/api";
import { errorHandling } from "../mixins";
import ProductCard from "../components/molecules/product-card";
import { mapMutations } from "vuex";

export default {
  name: "LandingPage",
  components: { ProductCard },
  mixins: [errorHandling],
  data() {
    return {
      selection: [],
      stores: [],
      brands: []
    };
  },
  methods: {
    visitRecommendationPage() {
      this.$router.push({ name: "Recommendations", params: { sex: "women" } });
    },
    visitProductMap() {
      this.$router.push({ name: "ProductMap" });
    },
    visitProductPage(product) {
      this.$router.push({
        name: "ProductPage",
        params: {
          name: product.name,
          id: product._id,
          sex: this.$route.params.sex
        }
      });
    },
    resolveStoreToLogo(store) {
      let url = `../assets/images/store_logos/${store}`;
      switch (store) {
        case "lumi_accessories":
          url += ".pdf";
          break;
        default:
          url += ".png";
          break;
      }
      return url;
    },
    visitStoreMap() {
      this.$router.push({ name: "stores" });
    },
    visitStorePage(storeName) {
      this.$router.push({ name: "StorePage", params: { store: storeName } });
    },
    visitBrandPage() {
      this.$router.push({ name: "brands" });
    },
    onLocateClick() {
      this.resetFilters();
      this.getSample();
      this.$router.push({ name: "ProductMap" });
    },
    async getSelection() {
      const response = await applyFilter({ numberOfItems: 4 });
      if (response.status === 201) {
        this.selection = response.data;
      } else {
        this.handleHttpError(response);
      }
    },
    async getStores() {
      const response = await getStores();
      if (response.status === 200) {
        this.stores = response.data;
      } else {
        this.handleHttpError(response);
      }
    },
    async getBrands() {
      const response = await getPossibleFilterValues("brand");
      if (response.status === 200) {
        const brands = response.data;
        brands.sort(() => Math.random() - 0.5);
        this.brands = brands.slice(0, 29);
      } else {
        this.handleHttpError(response);
      }
    },
    async getSample() {
      const response = await getSample();
      if (response.status === 200) {
        this.setProducts(response.data);
      } else {
        this.handleHttpError(response);
      }
    },
    ...mapMutations({
      resetFilters: "filters/reset"
    })
  },
  created() {
    this.getSelection();
    this.getStores();
    this.getBrands();
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.landing-page {
  min-height: 100vh;
}
.top {
  overflow: hidden;
  position: relative;
  min-height: 100vh;
  @media (min-width: $gyra-breakpoint-sm) {
    height: 885px;
  }
  width: 100%;
  background-color: white;
  border-top: 1px solid transparent;
  z-index: 0;

  h1 {
    font-size: 30px;
    margin: 80px 0 0 $gyra-margin-sides-mobile;
    @media (min-height: 811px) {
      margin: 100px 0 0 $gyra-margin-sides-mobile;
    }
    @media (min-width: $gyra-breakpoint-sm) {
      margin: 250px 0 0 $gyra-margin-sides;
      font-size: 50px;
    }
    @media (min-width: $gyra-breakpoint-xl) {
      margin: 300px 0 0 $gyra-margin-sides;
    }
    position: relative;
    z-index: 2;
  }

  p {
    margin: 45px 20px 0 calc(#{$gyra-margin-sides-mobile} + 46px);
    @media (min-width: $gyra-breakpoint-sm) {
      margin: 45px 0 0 calc(#{$gyra-margin-sides} + 46px);
      font-size: 20px;
    }
    max-width: 675px;
    font-size: 14px;

    font-weight: 500;
    position: relative;
    z-index: 2;
  }

  .shop-button-container {
    width: 100%;
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    margin-top: 100px;
    flex-direction: column;
    padding: 0;
    @media (min-width: $gyra-breakpoint-sm) {
      flex-direction: row;
      height: auto;
    }
    @media (min-width: $gyra-breakpoint-xl) {
      padding: 0 400px;
    }
    @media (min-height: 666px) {
      margin-top: 100px;
    }
    @media (min-height: 811px) {
      margin-top: 160px;
    }
    @media (min-width: $gyra-breakpoint-sm) {
      margin-top: 161px;
    }
    z-index: 2;
  }

  .shop-button {
    width: 275px;
    height: 58px;
    border-radius: 10px;
    box-shadow: 10px 10px 30px 0 rgba(0, 0, 0, 0.16);
    cursor: pointer;
    z-index: 2;

    display: flex;
    justify-content: center;
    align-items: center;
    color: $gyra-grey-dark;
    font-size: 16px;
    font-weight: bold;

    &:first-child {
      background-color: $gyra-salmon;
    }
    &:last-child {
      background-color: $gyra-mint;
    }
  }
  .map-image-pos {
    position: absolute;
    top: 0;
    right: -100px;
    height: 100%;
    width: 952px;
    z-index: 1;
    @media (min-width: $gyra-breakpoint-sm) {
      top: 0;
      right: 0;
    }
  }
  .gradient {
    background: rgb(255, 255, 255);
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 1) 8%,
      rgba(255, 255, 255, 0) 100%
    );
    @media (min-width: $gyra-breakpoint-sm) {
      background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 1) 0%,
        rgba(255, 255, 255, 1) 8%,
        rgba(255, 255, 255, 0) 100%
      );
    }
  }
  .map-image {
    background-size: cover;
    background-image: url("../assets/images/home/Landing Page Desktop.png");
  }
}

.title-and-button {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  margin-left: $gyra-margin-sides-mobile;
  margin-right: $gyra-margin-sides-mobile;
  @media (min-width: $gyra-breakpoint-lg) {
    margin-left: $gyra-margin-sides;
    margin-right: $gyra-margin-sides;
  }

  .title-emoji {
    display: flex;
    flex-direction: row;
  }

  h3 {
    margin-top: 52px;
    margin-right: 17px;
    font-size: 30px;
    font-weight: bold;
    @media (min-width: $gyra-breakpoint-lg) {
      font-size: 50px;
    }
  }
}

.more-button {
  margin-bottom: 8px;
  font-weight: 700;
  cursor: pointer;
  display: none;
  text-decoration: underline;
  @media (min-width: 660px) {
    display: block;
  }
}

.right-arrow {
  font-weight: bold;
  font-size: 24px;
  display: inline;
  cursor: pointer;
  margin-bottom: 8px;
  @media (min-width: 660px) {
    display: none;
  }
}

.store-row-container {
  overflow: scroll;
}

.stores,
.store-row-container {
  background-color: $gyra-grey-lightest;

  .store-row {
    margin-top: 83px;
    margin-bottom: 73px;
    display: flex;
    flex-direction: row;
    width: fit-content;
  }

  .store-container {
    width: 302px;
    height: 236px;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 86px;
    cursor: pointer;
    padding: 60px;

    &:last-child {
      margin-right: 86px;
    }

    .store-logo {
      width: 100%;
      height: 100%;
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
    }
  }
}

.selection {
  //padding: 52px $gyra-margin-sides 0 $gyra-margin-sides;
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;

  .product-row {
    margin: 20px $gyra-margin-sides-mobile 60px $gyra-margin-sides-mobile;

    @media (min-width: $gyra-breakpoint-lg) {
      margin: 60px $gyra-margin-sides 60px $gyra-margin-sides;
    }
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    @media (min-width: 910px) {
      flex-wrap: nowrap;
    }
  }
}

.banner {
  width: 100%;
  height: calc(0.5 * 100vw);

  @media (min-width: $gyra-breakpoint-md) {
    font-size: 80px;
    height: calc(0.3 * 100vw);
  }
  background-image: url("../assets/images/home/tom-brunberg-nZ9wWG8jRTQ-unsplash_2020-08-31/tom-brunberg-nZ9wWG8jRTQ-unsplash@3x.png");
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
  h3 {
    font-size: 34px;
    @media (min-width: $gyra-breakpoint-sm) {
      font-size: 60px;
    }
    @media (min-width: $gyra-breakpoint-md) {
      font-size: 80px;
    }
    @media (min-width: $gyra-breakpoint-lg) {
      font-size: 95px;
    }
    @media (min-width: $gyra-breakpoint-xl) {
      font-size: 120px;
    }
    font-weight: bold;
    color: $gyra-salmon;
  }
}

.brands {
  .brand-matrix {
    margin: 20px $gyra-margin-sides-mobile 107px $gyra-margin-sides-mobile;
    @media (min-width: $gyra-breakpoint-lg) {
      margin: 89px $gyra-margin-sides 107px $gyra-margin-sides;
    }

    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;

    .brand-container {
      width: 140px;
      @media (min-width: $gyra-breakpoint-sm) {
        width: 200px;
      }
      height: 60px;
      margin-right: 20px;
    }

    p {
      font-size: 14px;
      @media (min-width: $gyra-breakpoint-sm) {
        font-size: 16px;
      }
      margin: 0;
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
